var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stationId || _vm.createNewStation)?_c('StationDetails',{attrs:{"stationId":_vm.stationId,"createNew":_vm.createNewStation}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }